
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { SimpleAuthForm } from "@/components/auth/SimpleAuthForm";

export default function Auth() {
  const { user, loading } = useAuth();

  // Loading state check first
  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-black text-[#FFFCF3]">
        <div className="text-center">
          <div className="animate-spin h-8 w-8 border-t-2 border-[#089BDF] rounded-full mx-auto mb-4"></div>
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  // Authentication check after loading
  if (user) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="flex min-h-screen flex-col bg-black text-[#FFFCF3]">
      <main className="flex flex-1 flex-col items-center justify-center p-6">
        <div className="w-full max-w-md space-y-8">
          <div className="text-center">
            <h1 className="text-3xl font-bold">BeerDrop</h1>
            <p className="mt-2 text-gray-400">
              Sign in or create an account
            </p>
          </div>

          <SimpleAuthForm />
        </div>
      </main>
    </div>
  );
}
